import { fetchRetryParameters } from '~/composables/constants/api'
import type { DestinationInterface, DestinationPaymentProcessor } from '~/types/destinationTypes'

export default async () => {
  try {
    const destinations = await $fetch<DestinationInterface[]>('/api/auth/destinations', fetchRetryParameters)

    return destinations.filter((destination: DestinationInterface) => {
      return destination.payment_processors.some((paymentProcessor: DestinationPaymentProcessor) => {
        return paymentProcessor.active && paymentProcessor.enable_for_balance
      })
    })
  } catch (e) {
    return []
  }
}
